module.exports = __webpack_public_path__ + "img/oie-produkt-detalj-02-small.jpg";